import * as React from 'react'

import {
    useOnboardingStore,
    selectGuideSimplifiesImports,
} from '../stores/useOnboardingStore'

/**
 * Whether this import dialog is simplified: guide active AND at the `bring` stage,
 * sampled once at mount so a dialog never restructures under a user mid-form.
 * Positive gate, see selectGuideIsActive.
 */
export function useSimplifiedImportAtMount() {
    const [active] = React.useState(() =>
        selectGuideSimplifiesImports(useOnboardingStore.getState())
    )
    return active
}
